
import { observer } from 'mobx-react-lite';
//
import { SectionTab } from 'polotno/side-panel';
import { ImagesGrid } from 'polotno/side-panel/images-grid';
// import our own icon
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { faCrop, faCropAlt, faFont } from '@fortawesome/free-solid-svg-icons';
import { CircularProgress } from '@mui/material';
import { url } from '../../../services';
export const TextPanel = observer(({ store }) => {
    const [images, setImages] = useState([]);
    const [isMaxGet, setIsMaxGet] = useState(false);
    const [isHaveQueue, setIsHaveQueue] = useState(false);
    const maxTextLength = 100
    const [indexGetImg, setindexGetImg] = useState(0);
    async function loadImages(numbImg) {
        let listImg = Object.assign([], images)
        const maxNum = numbImg + 15
        for (numbImg; numbImg < maxNum; numbImg++) {
            if (numbImg > maxTextLength) {
                setIsMaxGet(true)
                break
            }
            else {
                listImg.push({ index: numbImg, url: url + 'resource/text/' + numbImg + '.jpg', data: url + 'resource/text/' + numbImg + '.json' })
            }
        }
        setImages(listImg);
    }

    useEffect(() => {
        loadImages(0);
    }, []);

    const handleScrollList = (event) => {
        if (!isMaxGet) {
            const element = event.target
            if (Math.round(element.scrollHeight - element.scrollTop) === element.clientHeight) {
                let newIndex = indexGetImg + 15
                setindexGetImg(newIndex)
                loadImages(newIndex);
            }
        }
    }
    return (
        <div className="list-image-container" onScroll={(e) => handleScrollList(e)}>
            {/* you can create yur own custom component here */}
            {/* but we will use built-in grid component */}
            <div id="list-image">
                {images.map((item, key) => (
                    <img src={item.url} alt="" key={key} className="img-item" onClick={async () => {
                        axios({
                            method: "GET",
                            url: item.data
                        }).then(res => {
                            const childrenRes = res.data.pages[0].children
                            childrenRes.forEach(async (item) => {
                                setIsHaveQueue(true)
                                store.activePage?.addElement(item)
                                await store.waitLoading();
                                setIsHaveQueue(false)
                            })
                        })
                    }} />
                ))}
            </div>
            {
                !isMaxGet ?
                    <div style={{ marginBottom: "1em", textAlign: "center" }}>
                        <CircularProgress />
                    </div> : null
            }
            {isHaveQueue ?
                <div style={{
                    position: "absolute",
                    top: 0,
                    height: "100%",
                    width: "100%",
                    backgroundColor: "rgba(255,255,255,0.5)",
                    textAlign: "center"
                }}>
                    <CircularProgress style={{
                        position: "fixed",
                        top: "50%",
                    }} />
                </div>
                : null}
        </div>
    );
});
// define the new custom section
export const CustomText = {
    name: 'Text',
    Tab: (props) => (
        <SectionTab name="Text" {...props}>
            <FontAwesomeIcon icon={faFont} />
        </SectionTab>
    ),
    Panel: TextPanel,
};